const initialState = {
	loading: false,
	errors: null,
	selectedWorkout: null,
	selectedMuxVideoUrl: null,
};

export default initialState;
